__turbopack_context__.v({
  "container": "_9asupa_container",
  "lowercase": "_9asupa_lowercase",
  "orderDetails": "_9asupa_orderDetails",
  "serviceTime": "_9asupa_serviceTime",
});
